import React from 'react';

const Loader = ({ fullPage = false, text = 'Loading...' }) => {
  if (fullPage) {
    return (
      <div className="page-loader">
        <div className="spinner spinner-lg"></div>
        {text && <p>{text}</p>}
      </div>
    );
  }

  return <div className="spinner"></div>;
};

export default Loader;
